import getConfig from 'next/config';
import { useEffect, useState } from 'react';
import EirActionModal from '../eir-action-modal/EirActionModal';
import fetchInfo from '../../../util/fetchModalData';

const { publicRuntimeConfig } = getConfig();

const MfaSuccessModal = ({ mfaSuccessModal }) => {
  const [cmsCollectionData, setCmsCollectionData] = useState({});
  const [load, setLoad] = useState(true);

  const getCmsData = async () => {
    try {
      const data = await fetchInfo({
        collectionType: 'eir-action-modals',
        modalID: 'mfa-setup-success-modal',
      });

      if (Object?.keys(data).length !== 0) {
        setLoad(false);
        setCmsCollectionData(data);
      }
    } catch (error) {
      console.error('error', error);
    }
  };
  const handleClose = () => {
    mfaSuccessModal.disable();

    if (window.resolveMFA) {
      window.resolveMFA(true); // signal success back to login

      delete window.resolveMFA;
    }
  };
  useEffect(() => {
    getCmsData();
  }, []);

  return (
    <EirActionModal
      id={cmsCollectionData?.attributes?.modalID || ''}
      open={mfaSuccessModal.value}
      handleClose={mfaSuccessModal.disable}
      iconSrc={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${
        cmsCollectionData?.attributes?.iconSrc?.data?.attributes?.url || ''
      }`}
      title={cmsCollectionData?.attributes?.title || ''}
      description={`${cmsCollectionData?.attributes?.firstHalfDescription || ''} `}
      cta={[
        {
          // text: 'Close',
          text: cmsCollectionData?.attributes?.cta[0]?.name
            ? cmsCollectionData?.attributes?.cta[0]?.name
            : 'Close',
          ariaLabel: cmsCollectionData?.attributes?.cta[0]?.ariaLabel
            ? cmsCollectionData?.attributes?.cta[0]?.ariaLabel
            : '',
          type: 'solid',
          action: () => handleClose(),
        },
      ]}
      disableCloseOnBackdropClick
      disableCloseOnEscapeKeyDown
      disablecta={false}
      load={load}
    />
  );
};
export default MfaSuccessModal;
